<script lang="ts">
  import RetailerIndex from "@distributor/svelte/RetailerIndex.svelte";
  import SalesforceChat from "@shared/services/salesforce_chat";
  import Spinner from "@shared/svelte/Components/Spinner.svelte";
  import { omitBy } from "lodash";
  import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import { onMount } from "svelte";
  import { params, goto } from "@roxi/routify";

  let paginationLimit = 50;
  let paginationEntries = 0;
  let retailerPage = Number($params.retailerPage || 1);
  let retailers = [];
  let isLoading = true;
  let filters = {
    search: $params.search,
    orderDay: $params.order_day,
    startDate: $params.start_date,
    endDate: $params.end_date,
    order: $params.order,
    direction: $params.direction || "DESC",
  };

  onMount(async () => {
    await load($params);
    SalesforceChat.initialize();
  });

  const load = async (params = {}) => {
    let res = await HttpPromiseWithEntireResponse({
      method: "GET",
      url: "/api/distributor/retailers",
      data: { with_latest_orders: true, page: retailerPage, ...params },
    });

    if (res.ok) {
      paginationEntries = Number(res.headers.get("X-Pagination-Entries"));
      paginationLimit = Number(res.headers.get("X-Pagination-Limit"));
      const retailersRes = await res.json();
      retailers = [...retailers, ...retailersRes];
    } else {
      retailers = [];
    }
    isLoading = false;
  };

  const loadMoreRetailers = async () => {
    let totalEntries = paginationEntries;
    let totalPages = Math.ceil(totalEntries / paginationLimit);

    if (retailerPage === totalPages) {
      return;
    }

    retailerPage += 1;
    await load();
  };

  const refreshState = async () => {
    retailerPage = 1;
    retailers = [];
    const filterParams = omitBy(filters, x => {
      return x === null || x === undefined || x === "null" || x === "undefined" || x === "";
    });

    $goto("/distributor/retailers", filterParams);
    await load(filterParams);
  };
</script>

{#if isLoading}
  <Spinner />
{:else}
  <div class="distributor-page">
    <RetailerIndex bind:retailers {refreshState} {filters} {loadMoreRetailers} />
  </div>
{/if}
